import { useFetchData } from '@va/util/hooks';
import { Key, SWRConfiguration } from 'swr';
import { useShouldFetchConditionally } from './useShouldFetchConditionally';

/** @deprecated */
export function useFetchConditionally<T, D = Error>(
  key: Key,
  shouldFetch: boolean,
  config?: SWRConfiguration,
  mapper?: (data: any) => T,
  fetchFunc?: (...args: any[]) => Promise<unknown>,
) {
  const { shouldFetchConditionally } = useShouldFetchConditionally(key, shouldFetch);

  return useFetchData<T, D>(shouldFetchConditionally ? null : key, config, mapper, fetchFunc);
}
